<template>
  <el-form
    :model="elementForm"
    ref="form"
    class="activity-form"
  >
    <div class="row">
      <div class="col" :class="{'col-xl-8 col-12': displayActivityLog }">
        <div class="row activity-form__boxes">
          <div class="col-xl-4 col-lg-4 col-sm-6 col-12">
            <div class="color-section-wrap">
              <div class="color-section" :class="classOrderPhase">
                <el-form-item
                  :label="labels['orderPhaseID']"
                  prop="orderPhaseID"
                  class="material-style"
                >
                  <select-response
                    :model.sync="form.orderPhaseID"
                    @on-change="(id, data) => autoSaveField('orderPhaseID', {
                      label: data && data.title,
                       payloadData: {
                        dateInPhase: new Date().toISOString()
                      }
                    })"
                    :isLoading="dataSourceOrderPhase.loading"
                    :data="dataSourceOrderPhase.records"
                  ></select-response>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-lg-4 col-sm-6 col-6">
            <div class="color-section-wrap">
              <div class="color-section" :class="classExchAgreementSigned">
                <el-form-item
                  prop="exchAgreementSigned"
                  :label="labels['exchAgreementSigned']"
                  class="material-style"
                  data-filed="true"
                >
                  <el-checkbox
                    v-model="form.exchAgreementSigned"
                    @change="autoSaveField('exchAgreementSigned')"
                  >
                  </el-checkbox>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="col-xl-2 col-lg-4 col-sm-4 col-6">
            <div class="color-section-wrap">
              <div class="color-section" :class="classUnitShipped">
                <el-form-item
                  prop="unitShipped"
                  :label="labels['unitShipped']"
                  class="material-style"
                  data-filed="true"
                >
                  <el-checkbox
                    v-model="form.unitShipped"
                    @change="autoSaveField('unitShipped')"
                  >
                  </el-checkbox>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-sm-4 col-6">
            <div class="color-section-wrap">
              <div class="color-section" :class="classCoreReceived">
                <el-form-item
                  prop="coreReceived"
                  :label="labels['coreReceived']"
                  class="material-style"
                  data-filed="true"
                >
                  <el-checkbox
                    v-model="form.coreReceived"
                    @change="autoSaveField('coreReceived')"
                  >
                  </el-checkbox>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-4 col-lg-4">
            <el-form-item
              :label="L10n('phase-employee')"
              prop="orderPhasePersonInChargeEmployeeID"
              class="material-style"
            >
              <select-response
                :model.sync="form.orderPhasePersonInChargeEmployeeID"
                @on-change="(id, data) => autoSaveField('orderPhasePersonInChargeEmployeeID', { label: data && data.title })"
                :isLoading="dataSourceEmployee.loading"
                :data="dataSourceEmployee.records"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-xl-4 col-lg-4">
            <el-form-item
              :label="L10n('date-in-phase')"
              prop="dateInPhase"
              class="material-style"
            >
              <date-picker
                v-model="form.dateInPhase"
                @change="autoSaveField('dateInPhase')"
              ></date-picker>
            </el-form-item>
          </div>
          <div class="col-xl-4 col-lg-4">
            <el-form-item
              :label="L10n('priority')"
              prop="priorityID"
              class="material-style"
            >
              <select-response
                :model.sync="form.priorityID"
                @on-change="(id, data) => autoSaveField('priorityID', { label: data && data.title })"
                :isLoading="dataSourcePriority.loading"
                :data="dataSourcePriority.records"
                :class="classPriority"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-lg-3 col-md-6">
            <el-form-item
              :label="L10n('reminder-date')"
              class="material-style"
              prop="reminderDate"
            >
              <date-picker
                v-model="form.reminderDate"
                @change="autoSaveField('reminderDate')"
              >
              </date-picker>
            </el-form-item>
          </div>
          <div class="col-lg-6 col-md-8">
            <el-form-item
              :label="L10n('subject')"
              class="material-style"
              prop="subject"
              :rules="getValidationRule('required')"
              :error="subjectError"
            >
              <select-response
                :model.sync="subject"
                :fields="{ id: 'subject', title: 'subject' }"
                :isLoading="dataSourceCompanyRemarks.loading"
                :data="dataSourceCompanyRemarks.records"
              ></select-response>
            </el-form-item>
          </div>
          <div class="col-lg-3 col-md-4">
            <el-form-item
              data-filed="true"
              class="material-style"
            >
              <ui-button
                class="btn btn-size-s btn-mobile-full"
                @click="onStatusEmail"
              >
                {{L10n('status-request-email')}}
              </ui-button>
            </el-form-item>
          </div>
          <div class="col-12 activity-form__user-actions">
            <ui-button
              class="btn btn-size-s btn-mobile-full"
              :disabled="disabledNewInstruction"
              @click="onNewInstruction"
            >
              {{L10n('send-new-instruction-to-support')}}
            </ui-button>
            <slot name="user-actions"></slot>
          </div>
        </div>
      </div>
      <div :class="{ 'col-xl-4 col-12': displayActivityLog}">
        <div v-if="displayActivityLog">
          <slot name="log-list"></slot>
          <div class="px-4 pt-4">
            <el-form-item
              :label="L10n('last-info')"
              class="material-style p-0"
              prop="lastInfo"
            >
              <el-input
                type="textarea"
                :rows="2"
                :value="form.lastInfo"
                @input="form.lastInfo = valueTrimLeft($event)"
                @change="autoSaveField('lastInfo')"
              >
              </el-input>
            </el-form-item>
          </div>
        </div>
        <vertical-collapse v-else>
          <template v-slot:title="{ toggle }">
            <ui-button
              style="height: 100%"
              class="btn btn-size-s"
              :label="L10n('activity-log')"
              isVertical
              @click.stop.prevent="toggle"
            />
          </template>
          <template>
            <slot name="log-list"></slot>
            <div class="p-4 mt-1">
              <el-form-item
                :label="L10n('last-info')"
                class="material-style"
                prop="lastInfo"
              >
                <el-input
                  type="textarea"
                  :rows="3"
                  :value="form.lastInfo"
                  @input="form.lastInfo = valueTrimLeft($event)"
                  @change="autoSaveField('lastInfo')"
                >
                </el-input>
              </el-form-item>
            </div>
          </template>
        </vertical-collapse>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
export default {
  name: 'ActivityForm',
  mixins: [Form],
  components: {
    'vertical-collapse': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/VerticalCollapse')
  },
  props: {
    displayActivityLog: { type: Boolean, required: true },
    disabledNewInstruction: { type: Boolean, default: true },
    subjectError: { required: true }
  },
  data () {
    return {
      subject: ''
    }
  },
  computed: {
    labels () {
      return {
        orderPhaseID: this.L10n('order-phase'),
        exchAgreementSigned: this.L10n('exch-agreement-signed'),
        unitShipped: this.L10n('unit-shipped'),
        coreReceived: this.L10n('core-received'),
        repairCostsApproved: this.L10n('repair-costs-approved'),
        unitReceivedCustomer: this.L10n('unit-received-customer')
      }
    },
    elementForm () {
      return { ...this.form, subject: this.subject }
    },
    dataSourceOrderPhase () {
      return this.API('orderPhases/GetAllDynamic?select=id,title&filter=!title.startsWith("Z_")&orderBy=title')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true&orderBy=name')
    },
    dataSourcePriority () {
      return this.API('Priorities/GetAllDynamic?select=id,title,isCritical&orderBy=title')
    },
    dataSourceCompanyRemarks () {
      return this.API('CompanyRemarkSubjects/GetAllDynamic?Select=subject&Filter=tableIndex==8&OrderBy=subject')
    },
    classPriority () {
      let priority = this.dataSourcePriority.map[this.form.priorityID]
      return {
        'color-red': priority && priority.isCritical
      }
    },
    classOrderPhase () {
      return {
        'border-x-orange': this.form.orderPhaseID !== 29,
        'border-x-none': this.form.orderPhaseID === 29
      }
    },
    classExchAgreementSigned () {
      return {
        'border-x-green': !!this.form.exchAgreementSigned,
        'border-x-none': !this.form.exchAgreementSigned
      }
    },
    classUnitShipped () {
      return {
        'border-x-green': !!this.form.unitShipped,
        'border-x-none': !this.form.unitShipped
      }
    },
    classCoreReceived () {
      return {
        'border-x-green': !!this.form.coreReceived,
        'border-x-none': !this.form.coreReceived
      }
    },
    classRepairCostsApproved () {
      return {
        'border-x-green': !!this.form.repairCostsApproved,
        'border-x-none': !this.form.repairCostsApproved
      }
    },
    classUnitReceivedCustomer () {
      return {
        'border-x-green': !!this.form.unitReceivedCustomer,
        'border-x-none': !this.form.unitReceivedCustomer
      }
    }
  },
  methods: {
    onStatusEmail () {
      this.$emit('onStatusEmail', { subject: this.subject })
    },
    onNewInstruction () {
      this.$emit('onNewInstruction', { subject: this.subject })
    }
  }
}
</script>
<style lang="stylus">
  .color-section-wrap{
    padding .5rem 0
  }
  .color-section{
    border-radius .2rem
    height 100%
    padding 1rem 1rem 0 1rem
    margin 0 -1rem
  }
</style>
